import type { ConfirmFunction, DialogOptions } from "~/components/ConfirmDialog.vue";

export const useAppConfirmDialog = () => {

  interface DialogProps extends DialogOptions {
    open: boolean;
  }

  const defaultUnsavedChangesDialogProps: DialogOptions = {
    title: 'Confirm',
    message: 'You have unsaved changes. Are you sure you want to leave?',
    color: 'warning',
    primaryActionLabel: 'Yes',
    secondaryActionLabel: 'Abort',
    persistent: true,
  };

  const defaultConfirmDeleteDialogProps: DialogOptions = {
    title: 'Delete',
    message: 'Delete the item?',
    color: 'warning',
    primaryActionLabel: 'OK',
    secondaryActionLabel: 'Cancel',
  };

  const confirmDialogProps = useState<DialogProps>('confirmDialogProps', () => (<DialogProps>{ open: false, }));
  const onConfirmCallback = useState<ConfirmFunction>('confirmDialogOnConfirmCallback', () => () => true);
  const onCancelCallback = useState<Function | undefined>('confirmDialogOnCancelCallback');

  const confirmUnsavedChanges = (dialogOptions?: DialogOptions): Promise<boolean> => {

    confirmDialogProps.value = {
      ...defaultUnsavedChangesDialogProps,
      ...dialogOptions,
      open: true,
    };

    return new Promise<boolean>((resolve) => {
      onConfirmCallback.value = () => {
        resolve(true);
        return true;
      };
      onCancelCallback.value = () => resolve(false);
    });
  };

  const showConfirmDeleteDialog = (message: string, onConfirmFunction: ConfirmFunction, dialogOptions?: DialogOptions) => {
    onConfirmCallback.value = onConfirmFunction;
    onCancelCallback.value = undefined;

    confirmDialogProps.value = {
      ...defaultConfirmDeleteDialogProps,
      message,
      ...dialogOptions,
      open: true,
    };
  };

  const showCustomConfirmDialog = (onConfirmFunction: ConfirmFunction, dialogOptions: DialogOptions) => {
    onConfirmCallback.value = onConfirmFunction;
    onCancelCallback.value = undefined;

    confirmDialogProps.value = {
      ...dialogOptions,
      open: true,
    };
  };

  return {
    confirmDialogProps,
    onConfirmCallback,
    onCancelCallback,
    confirmUnsavedChanges,
    showConfirmDeleteDialog,
    showCustomConfirmDialog
  };
};